import { BaseService } from '../../infra/base.service'
import type { Account } from './account'
import type { AccountsRepository } from './accounts.repository'

export class AccountsService extends BaseService<Account> {
    constructor(private rep: AccountsRepository) {
        super(rep)
    }

    async getIntegrationToken(accountId: string, pluggyId: string = null) {
        return await this.rep.getIntegrationToken(accountId, pluggyId)
    }

    async integrationLink(accountId: string, pluggyId: string = null) {
        return await this.rep.integrationLink(accountId, pluggyId)
    }

    async integrationUnlink(accountId: string) {
        return await this.rep.integrationUnlink(accountId)
    }

    async integrationGetTransactions(accountId: string) {
        return await this.rep.integrationGetTransactions(accountId)
    }
}
